// extracted by mini-css-extract-plugin
export default {"identityDocumentButton":"styles_identityDocumentButton__UB496","deleteButton":"styles_deleteButton__2--Hb"};